import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Button } from '@kambria/kambria-lego';

import CoreApprove from './coreApprove';


class Approve extends Component {
  constructor() {
    super();

    this.state = {
      dataset: [{ to: '', amount: '' }]
    }
  }

  more = () => {
    let newDataset = this.state.dataset;
    newDataset.push({ to: '', amount: '' });
    this.setState({ dataset: newDataset });
  }

  clear = () => {
    this.setState({ dataset: [] }, () => {
      this.setState({ dataset: [{ to: '', amount: '' }] });
    });
  }

  renderCoreApprove = (dataset) => {
    return dataset.map((item, i) => {
      return <CoreApprove key={i} to={item.to} amount={item.amount} />
    });
  }


  render() {
    return (
      <div className="container">
        <h2 className="title">Approve <i className="sync-btn fas fa-sync-alt" onClick={this.clear} /></h2>
        <table className="mx-auto w-100 position-relative" style={{ "top": "72px" }}>
          {this.renderCoreApprove(this.state.dataset)}
          <tbody>
            <tr>
              <td className="pr-0 pt-4">
                <Button onClick={this.more} type="secondary" size="sm" customStyle={{ "height": "40px" }}>+</Button>
              </td>
            </tr>
          </tbody>
        </table>
        <h3 className="definition">What is "Approve"?</h3>
        <p className="description d-block w-100 text-left">You are granting permission for the target address to spend a number of your token.</p>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  kat: state.kat
});

const mapDispatchToProps = dispatch => bindActionCreators({
  // Null
}, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Approve);